import type { MutationUpdaterFn } from '@apollo/client';

import type * as Schema from 'src/types/graphql';

export const generateUpdatePreferredClassificationOptimisticResponse =
  ({ _id }: { _id: string }) =>
  ({ input }: { input: Schema.UpdateClassificationInput }) => ({
    __typename: 'Mutation',
    updatePreferredClassification: {
      __typename: 'UpdatePreferredClassificationPayload',
      viewer: {
        __typename: 'Candidate',
        _id,
        preferredClassification: {
          __typename: 'Classification',
          id: input.classification.id,
          subClassification: {
            __typename: 'SubClassification',
            id: input.classification.subClassification.id,
          },
        },
      },
    },
  });

export const updateCacheUpdatePreferredClassification: MutationUpdaterFn<
  Schema.UpdatePreferredClassificationMutation
> = (cache, { data }) => {
  const _id = data?.updatePreferredClassification?.viewer?._id || '';
  const preferredClassification =
    data?.updatePreferredClassification?.viewer?.preferredClassification ||
    null;

  cache.modify({
    id: cache.identify({
      __typename: 'Candidate',
      _id,
    }),
    fields: {
      preferredClassification: () => preferredClassification,
    },
  });
};
